import { render, staticRenderFns } from "./ec_home.vue?vue&type=template&id=b167a808&name=ec_home"
import script from "./ec_home.vue?vue&type=script&lang=js"
export * from "./ec_home.vue?vue&type=script&lang=js"
import style0 from "./ec_home.vue?vue&type=style&index=0&id=b167a808&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_cache-loader@4.1.0_webpack@4.47.0__css-load_5d7fe198acc97e7377b1ebf5302390cf/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports